import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Invoices from './pages/Invoices';
import Hotels from './pages/Hotels';
import Companies from './pages/Companies';
import States from './pages/States';
import Reports from './pages/Reports';
import ProtectedRoute from './components/ProtectedRoute';
import { isAuthenticated } from './services/auth';

function LoginRoute() {
  const navigate = useNavigate();
  return <Login onLoginSuccess={() => navigate('/invoices')} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated() ? <Navigate to="/invoices" replace /> : <LoginRoute />}
        />
        <Route
          path="/invoices"
          element={<ProtectedRoute><Invoices /></ProtectedRoute>}
        />
        <Route
          path="/hotels"
          element={<ProtectedRoute><Hotels /></ProtectedRoute>}
        />
        <Route
          path="/companies"
          element={<ProtectedRoute><Companies /></ProtectedRoute>}
        />
        <Route
          path="/states"
          element={<ProtectedRoute><States /></ProtectedRoute>}
        />
        <Route
          path="/reports"
          element={<ProtectedRoute><Reports /></ProtectedRoute>}
        />
        <Route path="*" element={<Navigate to={isAuthenticated() ? '/invoices' : '/login'} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;